document.querySelector('form#create_customer').reset();
// Translation object
let registertranslations = {
  en: {
    requiredFields: "Please fill in all required(*) fields.",
    qatarIdRequired: "Qatar ID is required when accepting the terms.",
    invalidQatarMobile: "Please enter a valid Qatar mobile number.It must start with 3, 5, 6, or 7 and be 8 digits long.",
    invalidEmail: "Please enter a valid email address.",
    termsRequired: "You must agree to the terms and conditions.",
    otpSentSuccess: "OTP sent successfully!",
    otpVerificationFailed: "OTP verification failed.",
    otpRequired: "Please enter the OTP.",
    registrationComplete: "Registration completed! Redirecting...",
    registrationFailed: "Registration failed.",
    customerExistsLocal: "Customer already exists. Redirecting to login...",
    customerExistsERP: "Customer already exists . Please login",
    emailSentReset: "We have sent an email to reset your password. Please check your inbox.",
    noRegistrationData: "An error occurred: No registration data found.",
    otpError: "An error occurred while sending the OTP.",
    registrationError: "An error occurred during registration.",
    otpVerificationError: "An error occurred during OTP verification.",
    passwordMismatch: "Passwords do not match. Please re-enter both fields.",
    emailexists: "This email is already registered.",  // Added for email existence
    mobileexists: "This mobile number is already registered.",
    cannotRegister: "Email or Mobile already exists. Please Login",
    minCharacterPassword:"Password must be at least 5 characters long.",      
  },
  ar: {
    requiredFields: "يرجى ملء جميع الحقول المطلوبة (*)",
    qatarIdRequired: "رقم الهوية القطرية مطلوب عند الموافقة على الشروط.",
    invalidQatarMobile: "رقم الجوال غير صالح. يجب أن يبدأ بـ 3 أو 5 أو 6 أو 7 وأن يتكون من 8 أرقام يرجى إدخال رقم هاتف قطري صحي", 
    invalidEmail: "يرجى إدخال عنوان بريد إلكتروني صالح.",
    termsRequired: "يجب أن توافق على الشروط والأحكام.",
    otpSentSuccess: "تم إرسال رمز OTP بنجاح!",
    otpVerificationFailed: "فشل التحقق من رمز OTP.",
    otpRequired: "يرجى إدخال رمز OTP.",
    registrationComplete: "اكتمل التسجيل! جارٍ إعادة التوجيه...",
    registrationFailed: "فشل التسجيل.",
    customerExistsLocal: "العميل موجود بالفعل. جارٍ إعادة التوجيه لتسجيل الدخول...",
    customerExistsERP: "العميل مسجّل بالفعل. الرجاء تسجيل الدخول.",
    emailSentReset: "لقد أرسلنا بريدًا إلكترونيًا لإعادة تعيين كلمة المرور. يرجى التحقق من بريدك الوارد.",
    noRegistrationData: "حدث خطأ: لم يتم العثور على بيانات التسجيل.",
    otpError: "حدث خطأ أثناء إرسال رمز OTP.",
    registrationError: "حدث خطأ أثناء التسجيل.",
    otpVerificationError: "حدث خطأ أثناء التحقق من OTP.",
    passwordMismatch: "كلمات المرور غير متطابقة. يرجى إعادة إدخال كلا الحقلين.",
    emailexists: "هذا البريد الإلكتروني مسجل بالفعلر.",  // Added for email existence
    mobileexists: "رقم الهاتف هذا مسجل بالفعل." ,
    cannotRegister: "البريد الإلكتروني أو رقم الجوال موجود بالفعل",
    minCharacterPassword:"يجب أن تكون كلمة المرور مكونة من 5 أحرف على الأقل.",
  },
};

// Language selector (default: English)
let regcurrentLanguage = document.documentElement.lang || "en";
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onPageLoad);
} else {
  onPageLoad();
}
function onPageLoad(){

  const isValidQatarMobile = (phoneNumber) => {
  // Check if the number starts with +974 and is valid
  if (/^\+974[3567][0-9]{7}$/.test(phoneNumber)) {
    // Remove the +974 prefix and return the 8-digit number
    phoneNumber = phoneNumber.replace(/^\+974/, '');
  }

  // If no +974 prefix, validate as an 8-digit number
  if (/^[3567][0-9]{7}$/.test(phoneNumber)) {
    return phoneNumber; // Return the 8-digit number as it is valid
  }

  // If neither condition is met, return false
  return false; // Invalid number
};
const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const errorDiv = document.querySelector("#create_customer #register-error");
const otpUserMob = document.querySelector("#create_customer .user-details");
const sendOtpButton = document.querySelector("#create_customer #send-otp");
const otpSection = document.querySelector("#create_customer #otp-section");
const otpInput = document.querySelector("#create_customer #otp-input");
const otpError = document.querySelector("#create_customer #otp-error");
const regFieldsDiv = document.querySelector("#create_customer .register-field");
const showError = (messageKey,type="error") => {
const message = registertranslations[regcurrentLanguage][messageKey] || messageKey;
  if(type=="otp"){
    otpError.style.display = "block";
    otpError.innerText = message;
    // Remove previous classes and add the appropriate one
    otpError.classList.remove("error", "success");
    otpError.classList.add(type === "success" ? "success" : "error");
    otpError.setAttribute("tabindex", "-1"); // Make it focusable
    otpError.focus();
    otpError.scrollIntoView({ behavior: "smooth", block: "center" });
  }else{
    errorDiv.style.display = "block";
    errorDiv.innerText = message;
    // Remove previous classes and add the appropriate one
    errorDiv.classList.remove("error", "success");
    errorDiv.classList.add(type === "success" ? "success" : "error");
    errorDiv.setAttribute("tabindex", "-1"); // Make it focusable
    errorDiv.focus();
    errorDiv.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};
const clearError = () => {
  errorDiv.style.display = "none";
  errorDiv.innerText = "";
  errorDiv.classList.remove("error-fld"); // Remove classes

};
const showOtpSection = () => {
   sendOtpButton.style.display = "block";
    otpSection.style.display = "block";

  regFieldsDiv.style.display = "none";
  otpUserMob.innerText = document
    .getElementById("RegisterForm-mobnumber")
    .value.trim();
  otpSection.style.display = "block";
  otpInput.focus(); // Focus on the OTP input for better UX
};

const hideOtpSection = () => {
  sendOtpButton.style.display = "none";
  otpSection.style.display = "none";
  otpInput.value = ""; // Clear the OTP input
};
function validateAndMove(input, nextId) {
  // Allow only numbers
  if (!/^\d$/.test(input.value)) {
    input.value = ""; // Clear invalid input
    return;
  }

  // Move focus to the next field if valid
  if (nextId) {
    document.getElementById("otp" + nextId).focus();
  }
}

function startTimer() {
  let countdownTime = 60; // Timer in seconds
  const timerElement = document.getElementById("timerText");
  const resendButton = document.getElementById("resendButton");
  const timerDiv = document.getElementById("timer");

  // Reset display
  timerDiv.style.display = "block";
  resendButton.style.display = "none";
  timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;

  const interval = setInterval(() => {
    countdownTime--;

    // Update the timer text
    timerElement.textContent = `Resend OTP in: ${countdownTime} seconds`;

    // When the countdown ends
    if (countdownTime <= 0) {
      clearInterval(interval);
      timerDiv.style.display = "none";
      resendButton.style.display = "block"; // Show the Resend OTP button
    }
  }, 1000);
}

async function sendOrResendOTP(action) {
  try {
    // Retrieve the form data from localStorage
   /* const storedData = localStorage.getItem("regdata");
    if(action=="resend_otp"){
       delete storedData.action;
    }
    const formData = storedData ? JSON.parse(storedData) : null;*/
    // Retrieve the regdata from localStorage and parse it into an object
let storedData = localStorage.getItem("regdata");
storedData = storedData ? JSON.parse(storedData) : {};

// Check the action and delete it if action is 'resend_otp'
    delete storedData.action;


// Save the modified data back to localStorage
localStorage.setItem("regdata", JSON.stringify(storedData));

// Retrieve and log the updated data
const updatedData = JSON.parse(localStorage.getItem("regdata"));
//console.log(updatedData);

// Assign the updated data to formData
const formData = updatedData || null;


    if (!formData) {
      showError("noRegistrationData");
      return;
    }

    const response = await sendRequest(action, formData);

    if (response.ok && response.data.status === "otp_sent") {
      clearError();
      showError("otpSentSuccess","success");
      showOtpSection();
      startTimer();
      setupOtpVerification(formData);
    } else {
      showError(response.data.message || "Failed to send OTP.");
    }
  } catch (error) {
   // console.error(`Error during ${action} OTP:`, error);
    showError("otpError");
  }
}

document.getElementById("resendButton").addEventListener("click", () => {
  
   sendOrResendOTP("resend_otp");
});
  function validateQatarId(qid) {
    const qidPattern = /^[23]\d{10}$/;
    return qidPattern.test(qid);
}
  // Function to validate required fields dynamically
function validateRequiredFields(fields) {
  let isValid = true;

  fields.forEach((field) => {
    // Check if the field is empty
    if (!field.value.trim()) {
      isValid = false;
      field.classList.add('error'); // Highlight the invalid field
    } else {
      field.classList.remove('error'); // Remove error highlight if valid
    }
  });

  return isValid;
}
let emailError = false;
let mobileError = false;

const updateErrorState = () => {
  if (emailError || mobileError) {
   
   showError("customerExistsERP"); // General error message for registration prevention
  } else {
    clearError(); // Clear all errors if both fields are valid
  }
};
  // Highlight fields with errors
const highlightField = (fieldId, hasError) => {
  const field = document.getElementById(fieldId);
  if (hasError) {
    field.classList.add("error-fld");
  } else {
    field.classList.remove("error-fld");
  }
};




// Form submission handler
document.querySelector("#customer-register-button").addEventListener("click", async (e) => {
    e.preventDefault();
      
    const formData = {
      action: "register",
      first_name: document
        .getElementById("RegisterForm-FirstName")
        .value.trim(),
      last_name: document.getElementById("RegisterForm-LastName").value.trim(),
      email: document.getElementById("RegisterForm-email").value.trim(),
      mobile: document.getElementById("RegisterForm-mobnumber").value.trim(),
      password: document.getElementById("RegisterForm-password").value.trim(),
      confirm_password: document
        .getElementById("RegisterForm-confirm_password")
        .value.trim(),
      gender: document.getElementById("gender").value,
      birth_date: document.getElementById("date-selector").value,
      qatar_id: document.getElementById("accept1").checked
        ? document.getElementById("qtar_id").value.trim()
        : null,
    };


    const requiredFields = [
  document.getElementById("RegisterForm-FirstName"),
  document.getElementById("RegisterForm-LastName"),
  document.getElementById("RegisterForm-email"),
  document.getElementById("RegisterForm-mobnumber"),
  document.getElementById("RegisterForm-password"),
  document.getElementById("RegisterForm-confirm_password"),
  document.getElementById("gender")
];

// Validate required fields
if (!validateRequiredFields(requiredFields)) {
  showError("requiredFields");
  return;
}

    // Validate Qatar ID if accept1 is checked
    if (document.getElementById("accept1").checked && !formData.qatar_id) {
      showError("qatarIdRequired");
      return;
    }

    // Validate Qatar mobile number
    if (!isValidQatarMobile(formData.mobile)) {
      showError(
        "invalidQatarMobile"
      );
      return;
    }

    // Validate email address
    if (!isValidEmail(formData.email)) {
      showError("invalidEmail");
      return;
    }

    // Validate terms acceptance
    if (!document.getElementById("accept2").checked) {
      showError("termsRequired");
      return;
    }
   
    const password = formData.password;
  
    if (!password || password.length < 5) {
    //  console.error("Password must be at least 5 characters long.");
      showError("minCharacterPassword");
      return false; // Validation failed
    }
  
 // Validate password and confirm password
    if (formData.password !== formData.confirm_password) {
      showError("passwordMismatch");
      return;
    }
    // Check if there are any errors on the fields before submitting the form
    const hasError = document.querySelectorAll(".error-fld").length > 0;
    if (hasError) {
      showError("cannotRegister");
      return;
    }
    try {
      const response = await sendRequest("register", formData);

      if (response.ok && response.data.status === "otp_sent") {
        clearError(); // Store the data in localStorage
        // Remove the "action" key
       
        localStorage.setItem("regdata", JSON.stringify(formData));
        showOtpSection();
        startTimer();
        setupOtpVerification(formData);
      } else if (response.ok && response.data.status === "error") {
         if (response.data.message.includes("Customer exists ")) {
          showError("customerExistsERP");
          const paragraph = document.querySelector("#email_recovary p");
          if (paragraph) {
            paragraph.innerHTML =
              "We have sent an email to reset your password. Please check your inbox.";
          } else {
          //  console.error("Paragraph element not found in #email_recovary.");
          }
          setTimeout(() => {
            //document.querySelector('a[data-id="email_recovary"]').click();
             window.location.href = "/account/login#recover"; // ERP customer exists
          }, 1000);
        } else if (response.ok && response.data.status === "exists") {
           window.location.href = "/account/login";
        } else {
          showError(response.data.message || "registrationFailed");
        }
      }
    } catch (error) {
      //console.error("Error during registration:", error);
      showError("registrationError");
    }
  });
    const registerButton = document.getElementById("customer-register-button");

  let customerExistFlag =false ;
  // Function to update button state
function updateRegisterButton() {
    if (customerExistFlag) {
        registerButton.disabled = true;
    } else {
        registerButton.removeAttribute("disabled");
    }
}
  // Email field blur event to check if email exists
document.getElementById("RegisterForm-email").addEventListener("change", async () => {
  const email = document.getElementById("RegisterForm-email").value.trim();
  const mobile = document.getElementById("RegisterForm-mobnumber").value.trim();
  
  if (email) {
    try {
      const response = await sendRequest("check_customer_exists", { mobile :mobile,email:email });
      if (response.ok && response.data.status === "exists") {
        emailError = true;
        customerExistFlag =true;
        showError("emailexists"); // This should trigger the error message
        highlightField("RegisterForm-email", true); // Ensure the field is highlighted with error
        
      } else {
        emailError =false;
        customerExistFlag =false;
        highlightField("RegisterForm-email", false); // Remove highlight if valid
      }
    } catch (error) {
      emailError =true;
     // console.error("Error during email check:", error);
      showError("registrationError");
      highlightField("RegisterForm-email", true);
    }
  } else {
    emailError =false;
    highlightField("RegisterForm-email", false); // Remove highlight if no email entered
  }
  updateErrorState();
  updateRegisterButton();
});
// Check if the mobile number exists
document.getElementById("RegisterForm-mobnumber").addEventListener("change", async () => {
  const mobile = document.getElementById("RegisterForm-mobnumber").value.trim();
  const email = document.getElementById("RegisterForm-email").value.trim();

  if (mobile) {
    try {
      const response = await sendRequest("check_customer_exists", { mobile :mobile,email:email});

      if (response.ok && response.data.status === "exists") {
        mobileError = true;
        customerExistFlag =true;
        
        showError("mobileexists"); // Mobile number already exists error message
        highlightField("RegisterForm-mobnumber", true);
      } else {
        mobileError = false;
        customerExistFlag =false;
        
        highlightField("RegisterForm-mobnumber", false);
      }
    } catch (error) {
     // console.error("Error during mobile check:", error);
      showError("registrationError"); // Handle any general errors
      mobileError = true; // Assume an error state
      highlightField("RegisterForm-mobnumber", true);
    }
  } else {
    mobileError = false;
    highlightField("RegisterForm-mobnumber", false);
  }
  updateErrorState();
  //console.log(`Flag${customerExistFlag}`);
  updateRegisterButton();
});
  
const setupOtpVerification = (formData) => {
  // Select elements


  // Ensure all elements exist
  if (!sendOtpButton || !otpInput || !otpError) {
   // console.error("Required elements not found in the DOM.");
    return;
  }

  // Add click event listener
  sendOtpButton.addEventListener("click", async () => {
    let otpValue = "";

    // Collect OTP from input fields
    for (let i = 1; i <= 6; i++) {
      const otpField = document.querySelector(`#create_customer #otp${i}`);
      if (!otpField) {
       // console.error(`OTP field #otp${i} not found.`);
        return;
      }
      otpValue += otpField.value.trim();
    }

    // Set OTP value
    otpInput.value = otpValue;

    // Validate OTP
    if (!otpValue) {
      otpError.innerText = "Please enter the OTP.";
      otpError.style.color = "red"; // Optional: Style error message
      otpInput.focus();
      return;
    }

    otpError.innerText = ""; // Clear any existing error message

    // Call verifyOtp function
    try {
      await verifyOtp(otpValue, formData);
     // console.log("OTP verified successfully.");
    } catch (error) {
      otpError.innerText = error.message || "Failed to verify OTP.";
     // console.error("Error verifying OTP:", error);
    }
  });
};

// const setupOtpVerification = (formData) => {
//   sendOtpButton.addEventListener("click", async () => {
//     // Collect OTP from the input boxes
//     let otpValue = "";
//     for (let i = 1; i <= 6; i++) {
//       otpValue += document.querySelector("#create_customer #otp" + i).value;
//     }
//     otpInput.value = otpValue;
//     const otp = otpInput.value.trim();
//     if (!otp) {
//       otpError.innerText = "Please enter the OTP.";
//       otpInput.focus();
//       return;
//     }
//     otpError.innerText = "";
//     await verifyOtp(otp, formData);
//   });
// };
// OTP verification
async function verifyOtp(otp, formData) {
  try {
    const { action, ...filteredFormData } = formData;

    const requestData = {
      action: "verify_otp",
      data: filteredFormData,
      otp: otp,
    };

    const response = await sendRequest("verify_otp", requestData);

    if (response.ok && response.data.status === "success") {
      clearError();
      showError("registrationComplete","success");
      setTimeout(() => {
          loginUserFromdb(filteredFormData.email, filteredFormData.password);
       }, 800
     );
    } else {
      showError(response.data.message || "otpVerificationFailed",'otp');
    }
  } catch (error) {
   // console.error("Error during OTP verification:", error);
    showError("otpVerificationError.","otp");
  }
}
//login user
// async function loginUser(email, password) {
//   const form = document.createElement("form");
//   form.method = "POST";
//   form.action = "/account/login";

//   const emailField = document.createElement("input");
//   emailField.type = "hidden";
//   emailField.name = "customer[email]";
//   emailField.value = email; // Assign email
//   form.appendChild(emailField);

//   const passwordField = document.createElement("input");
//   passwordField.type = "hidden";
//   passwordField.name = "customer[password]";
//   passwordField.value = password; // Assign password

//   form.appendChild(passwordField);

//   document.body.appendChild(form);
//   form.submit();
// }
 // document.getElementById("resendButton").addEventListener("click", () => {
 //    sendOrResendOTP("resend_otp");
 //  });
 async function loginUserFromdb(email, password) {
   
 
   try {
    
      // // Send the login request
      // const response = await sendRequest("login_email", {
      //   email: email.trim(),
      //   password: password.trim(),
      // });
    
      // // Ensure response and data exist
      // if (!response || !response.data) {
      //   throw new Error("Unexpected response structure");
      // }
      // const res = response.data;

     // if (response.ok && res.status === "success") {
       if(email !="" &&  password !=""){
        try {
          const response = await fetch("/account/login", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded", // Required for form data
            },
            body: new URLSearchParams({
              form_type: "customer_login",
              "customer[email]": email,
              "customer[password]": password,
            }),
          });

          if (response.ok) {
         
           // Redirect to account page on success
               const redirectUrl = regcurrentLanguage === 'ar' ? '/ar/account' : '/account';
                //if login/account creation from checkout
                if(localStorage.getItem("offerCheckout")=="1"){
                  alert(email);
                  startCheckoutProcess(email);
                }else{
                  window.location.replace(redirectUrl);
                }
           
          } else {
            // Handle error response
            const errorData = await response.text();
            //console.error("Login failed:", errorData);
          }

        }catch (error) {
          // Handle network errors
         //console.error("Request error:", error);
        }
      }
     // else if (response.ok && res.status === "error") {
     //    // Handle login error with a specific message
     //    const errorMessage = res.message || "An unknown error occurred.";
     //    showError(errorMessage);
     //    return false;
     //  } else {
     //    // Fallback for unexpected statuses
     //    throw new Error("Unexpected status in response");
     //  }
  } catch (error) {
    //console.error('Error during login:', error);
    showError('An error occurred while trying to log in. Please try again later.', 'error');
  }
}
   
// Common fetch request function
async function sendRequest(action, data) {
  const response = await fetch(
    "https://app.rafpharmacy.com/api/customer/post",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action, ...data }),
    }
  );
  const result = await response.json();
  return { ok: response.ok, data: result };
}

// Toggle Qatar ID field
document.getElementById("accept1").addEventListener("change", function () {
  const qatarIdField = document.getElementById("qatar-id-field");
  qatarIdField.style.display = this.checked ? "block" : "none";
  if (!this.checked) document.getElementById("qtar_id").value = "";
});
// Validate Qatar ID only if checkbox is checked
document.getElementById("qtar_id").addEventListener("change", function () {
    const qidInput = this.value.trim();
    const isChecked = document.getElementById("accept1").checked;

    // If checkbox is not checked, ignore validation
    if (!isChecked) {
        //clearError("qtar_id");
        //highlightField("qtar_id", false);
        return;
    }

    // Validate only if checkbox is checked
    if (qidInput === "") {
        showError("qatarIdRequired");
      return false;
        //highlightField("qtar_id", true);
    } else if (!validateQatarId(qidInput)) {
        showError("Invalid Qatar ID. Please enter valid Qatar ID.", "qtar_id");
      return false;
    } else {
       
    }
});  
}